export default __webpack_public_path__ + "img/61331684267b01a575984ef4a5e01929.jpg";